import { ChildModel, ModelBase } from 'store/model-base';
import { PromotionType } from 'core/constants';
import { PromoEligibilityServices } from './promo-eligibility';
import { TradeInInfo } from './trade-in-info';


export interface PromoEligibleArgs {
    newLine?: boolean;
    ndel?: boolean;
    isDpp?: boolean;
    isBtg?: boolean;
    isPortIn?: boolean;
    hasXmpp?: boolean;
    isByod?: boolean;
    pif?: boolean;
    dpp?: boolean;

}
//FULL LIST OF POSSIBLE PROMO ELIGIBLE ARGS
// If you wonder why API has "upgrade" but we don't have it here, it is because "upgrade" is only for XM AX and we need to ignore this property
// newLine?: boolean;
// ndel?: boolean;
// pif?: boolean;
// dpp?: boolean;
// portIn?: boolean;
// newNum?: boolean;
// btg?: boolean;
// unl?: boolean;
// xmpp?: boolean;
// byod?: boolean;
// tip?: boolean;

export class Promotion extends ModelBase {
    public static storeName: string = 'promotion';
    public static idAttribute: string = 'id';

    public id: string;
    public value: number;
    public valueTotal: number;
    public percentValue: number;
    public type: PromotionType;
    public startDate: string;
    public endDate: string;
    public promotionDescription: string;
    public promotionPrice: number;
    public eligibilityServices: PromoEligibilityServices;
    public promotionTerm: number;
    public promoBOID: string;
    public isTradeInPromo: boolean;
    public isTradeInPromoNewLine: boolean;
    public isTradeInPromoExistingLine: boolean;
    public isTradeInPromoDDA: boolean;
    public isTradeInPromoDDANewLine: boolean;
    public isTradeInPromoPlusUp: boolean;
    public isTradeInPromoPlusUpNewLine: boolean;
    public isExtendedPromoExistingLine: boolean;
    public tradeinInfo: TradeInInfo[];
    public plusUpValue: number;

    public isPrepaid: boolean;
    public isPercentage: boolean;
    public isDollarAmount: boolean;
    public isExtendedPromo: boolean;
    public isSubsidy: boolean;
    public isExtendedPromoPCT: boolean;
    public isExtendedPromoDollar: boolean;
    public isExtendedPromoPhase2: boolean;

    public isExtendedPromoNewLine: boolean;
    public isExtendedDDAPromo: boolean;
    public isExtendedDDAPromoNewLine: boolean;
    public isPortInRequired: boolean;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.eligibilityServices = data.eligibilityServices || {};

        data.isPrepaid = data.type === PromotionType.GIFT_CARD;
        data.isPercentage = data.type === PromotionType.PERCENTAGE;
        data.isDollarAmount = data.type === PromotionType.DOLLAR_AMOUNT;
        data.isExtendedPromo = data.type === PromotionType.EXTENDED_PROMO;
        data.isExtendedPromoExistingLine = data.type === PromotionType.EXTENDED_PROMO_UPGRADE;
        data.isExtendedPromoPCT = data.type === PromotionType.EXTENDED_PROMO_PCT;
        data.isExtendedPromoDollar = data.type === PromotionType.EXTENDED_PROMO_DOLLAR;
        data.isExtendedPromoPhase2 = data.isExtendedPromoPCT || data.isExtendedPromoDollar;
        data.isExtendedPromoExistingLine = data.type === PromotionType.EXTENDED_PROMO_UPGRADE;
        data.isExtendedPromoNewLine = data.isExtendedPromoPCT || data.isExtendedPromoDollar;
        data.isExtendedDDAPromo = data.type === PromotionType.EXTENDED_PROMO_DOLLAR_DDA;
        data.isExtendedDDAPromoNewLine = data.isExtendedDDAPromo && data.eligibilityServices.newLine;
        data.isSubsidy = data.type === PromotionType.SUBSIDY;
        data.isTradeInPromo = data.type === PromotionType.TRADEIN_PROMO;
        data.isTradeInPromoNewLine = data.isTradeInPromo && data.eligibilityServices.newLine;
        data.isTradeInPromoDDA = data.type === PromotionType.TRADEIN_PROMO_DDA;
        data.isTradeInPromoDDANewLine = data.isTradeInPromoDDA && data.eligibilityServices.newLine;
        data.isTradeInPromoPlusUp = data.type === PromotionType.TRADEIN_PROMO_PLUSUP;
        data.isTradeInPromoPlusUpNewLine = data.isTradeInPromoPlusUp && data.eligibilityServices.newLine;

        data.isPortInRequired = data.eligibilityServices.portIn;

        return super.create<T>(data);
    }

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'eligibilityServices',
            model: PromoEligibilityServices
        }];
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'tradeinInfo',
            model: TradeInInfo
        }];
    }

    public replaceStringWithPromoValue(rawString: string): string {
        return rawString && rawString.replace('[PROMO_PCT]', `${this.percentValue}%`).replace('[PROMO_DOLLAR]', `$${Math.round(this.valueTotal)}`).replace('[PROMO_DOLLAR_MONTHLY]', `$${this.value}`);
    }

    public isPromoEligible(args: PromoEligibleArgs): boolean {
        const argsWithDefault: PromoEligibleArgs = {
            hasXmpp: args.hasXmpp === undefined ? true : args.hasXmpp,
            isDpp: args.isDpp === undefined ? true : args.isDpp,
            isBtg: args.isBtg === undefined ? true : args.isBtg,
            isByod: args.isByod === undefined ? true : args.isByod,
            isPortIn: args.isPortIn === undefined ? true : args.isPortIn
        };

        if (this.eligibilityServices.dpp && !argsWithDefault.isDpp) {
            return false;
        }

        if (this.eligibilityServices.btg && !argsWithDefault.isBtg) {
            return false;
        }

        if (this.eligibilityServices.unl && argsWithDefault.isBtg) {
            return false;
        }

        if (this.eligibilityServices.byod && !argsWithDefault.isByod) {
            return false;
        }

        if (this.eligibilityServices.newNum && argsWithDefault.isPortIn) {
            return false;
        }

        if (this.eligibilityServices.portIn && !argsWithDefault.isPortIn) {
            return false;
        }

        if (this.eligibilityServices.xmpp && !argsWithDefault.hasXmpp) {
            return false;
        }

        return true;
    }
}
